import { useContext, useCallback, useMemo } from "react";
import { ToastContext } from "../contexts/toast-context";
/**
 * Hook customizado para exibir notificações toast de forma padronizada.
 * Utiliza o componente Toast do @uigovpe/components via Context.
 */
export var useToast = function () {
    var context = useContext(ToastContext);
    if (!context) {
        throw new Error("useToast deve ser usado dentro de um ToastProvider");
    }
    var show = context.show, clear = context.clear;
    /**
     * Exibe um toast de sucesso.
     */
    var success = useCallback(function (message, summary) {
        if (summary === void 0) { summary = "Sucesso"; }
        show({
            severity: "success",
            summary: summary,
            detail: message,
            life: 3000,
        });
    }, [show]);
    /**
     * Exibe um toast de erro.
     */
    var error = useCallback(function (message, summary) {
        if (summary === void 0) { summary = "Erro"; }
        show({
            severity: "error",
            summary: summary,
            detail: message,
            life: 5000,
        });
    }, [show]);
    /**
     * Exibe um toast de informação.
     */
    var info = useCallback(function (message, summary) {
        if (summary === void 0) { summary = "Informação"; }
        show({
            severity: "info",
            summary: summary,
            detail: message,
            life: 3000,
        });
    }, [show]);
    /**
     * Exibe um toast de aviso.
     */
    var warning = useCallback(function (message, summary) {
        if (summary === void 0) { summary = "Aviso"; }
        show({
            severity: "warn",
            summary: summary,
            detail: message,
            life: 3500,
        });
    }, [show]);
    return useMemo(function () { return ({
        success: success,
        error: error,
        info: info,
        warning: warning,
        clear: clear,
    }); }, [success, error, info, warning, clear]);
};
